import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { VpsPlansState } from './types'
import { IVpsPlan } from '@/types/vps-plan.interface'
import getVpsPlanExtraParams from '@/utils/helpers/get-vps-plan-extra-params.helper'

const initialState: VpsPlansState = {
  list: [],
}

const vpsPlansSlice = createSlice({
  name: 'vps-plans',
  initialState,
  reducers: {
    setVpsPlans: (state, action: PayloadAction<IVpsPlan[]>) => {
      state.list = action.payload.map((plan) => getVpsPlanExtraParams(plan))
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.vpsPlans,
      }
    })
  },
})

export const { setVpsPlans } = vpsPlansSlice.actions

export default vpsPlansSlice
